export default {
  public_key: process.env.REACT_APP_STRIPE_PUBLIC_KEY,
  checkout_success_url: process.env.REACT_APP_STRIPE_SUCCESS_URL,
  checkout_cancel_url: process.env.REACT_APP_STRIPE_CANCEL_URL
}